<template>
  <v-app v-resize="onResize">
    <core-toolbar />
    <router-view />
    <core-footer id="cfooter"/>
    <btn-fixed>Schedule a consultation</btn-fixed>
  </v-app>

</template>

<script>
export default {
  components: {
    CoreFooter: () => import('@/components/core/Footer'),
    CoreToolbar: () => import('@/components/core/Toolbar')
  },
  data: () => ({
    mobile: false
  }),
  mounted () {
    this.getFooterHeight()
  },
  methods: {
    onResize () {
      this.mobile = window.innerWidth < 960
    },
    getFooterHeight () {
      let footer = document.querySelector('#cfooter')
      console.log(footer)
    }
  }
}
</script>
